import React from "react";
import { Badge } from "@/components/ui/badge";

const MAP = {
  paid: { label: "Paid", cls: "border-primary/40 text-primary bg-primary/10" },
  pending: { label: "Awaiting payment", cls: "border-secondary/40 text-secondary bg-secondary/10" },
  failed: { label: "Payment failed", cls: "border-destructive/40 text-destructive bg-destructive/10" },
  underpaid: { label: "Needs review", cls: "border-amber-500/50 text-amber-700 bg-amber-500/10" },
};

export const PaymentBadge = ({ status, needsReview, testid }) => {
  const key = needsReview && status !== "paid" ? "underpaid" : status;
  const cfg = MAP[key] || { label: status || "unknown", cls: "border-border text-muted-foreground" };
  return (
    <Badge variant="outline" className={`text-[10px] font-medium ${cfg.cls}`} data-testid={testid}>
      {cfg.label}
    </Badge>
  );
};

export default PaymentBadge;
